import { render, staticRenderFns } from "./ProjectJournalsTTableJournalRow.vue?vue&type=template&id=44e85cd6&scoped=true&"
import script from "./ProjectJournalsTTableJournalRow.vue?vue&type=script&lang=ts&"
export * from "./ProjectJournalsTTableJournalRow.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectJournalsTTableJournalRow.vue?vue&type=style&index=0&id=44e85cd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e85cd6",
  null
  
)

export default component.exports